import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useGraphneAPI, ApiSimulationParameterValue } from '@nexelem/graphne-api';
import { useCustomToast } from '@nexelem/snackbar';
import { useCustomTranslation } from '../../../../../hooks';
import { extractResponseErrorMessage } from '@nexelem/utils';
import { SIMULATION_LIST_ROUTE_KEY } from '../SimulationList/constants';

export const useGraphneSimulationCreateMutate = () => {
  const api = useGraphneAPI();
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const displayToast = useCustomToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (parameterValues: ApiSimulationParameterValue[]) =>
      api.postGraphneSimulationCreate({
        simulationCreateOptimizeView: {
          parameterValues,
        },
      }),
    onSuccess: () => {
      displayToast({
        toastType: 'success',
        message: tWrapper('simulationCreatedToast'),
      });
      queryClient.invalidateQueries({ queryKey: [SIMULATION_LIST_ROUTE_KEY] });
    },

    // TODO - naprawić typowanie errora, musi uwzględniać response. To samo w useGraphneSimulationOptimize.
    onError: async (err: Error) => {
      const message = await extractResponseErrorMessage(err);
      displayToast({
        toastType: 'error',
        message: `${tWrapper('cannotCreateSimulation')} ${message}`,
      });
    },
  });
};
